import './CartButton.scss';

import cn from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ROUTE_CARTS, ROUTE_ECATALOGS } from '@/common/constants';
import { useDefaultCartContext } from '@/common/contexts/DefaultCartContext';
import { useMiniCartContext } from '@/common/contexts/MiniCartContext/MiniCartContext';
import { ReactComponent as BasketSvg } from '@/ebat/assets/icons/basket.svg';
import CartNavLink from '@/ebat/components/blocks/Header/CartButton/CartNavLink/CartNavLink';
import DisabledCartButton from '@/ebat/components/blocks/Header/CartButton/DisabledCartButton/DisabledCartButton';
import NewCartButton from '@/ebat/components/blocks/Header/CartButton/NewCartButton/NewCartButton';
import { useHeaderAccessesContext } from '@/ebat/contexts/Header/HeaderAccessesContext/HeaderAccessesContext';
import { ROUTE_CART } from '@/materiaux/constants';

import {
  CartButtonDefaultProps,
  CartButtonPropTypes,
} from './CartButton.proptypes';

const CartButton = ({ className }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { defaultCart } = useDefaultCartContext();
  const {
    carts: hasCartAccesses,
    cartsCreate: hasCreateAccess,
  } = useHeaderAccessesContext();
  const location = useLocation();
  const defaultCartId = defaultCart?.id ?? null;
  const isActive = pathname.startsWith(ROUTE_CARTS);
  const { setIsVisible, setCartButtonRef } = useMiniCartContext();
  const isCartPage = location.pathname.includes(ROUTE_CART);
  const isEcatalogPage = location.pathname.includes(`${ROUTE_ECATALOGS}/`);
  const cartButtonRef = useRef(null);

  useEffect(() => {
    setCartButtonRef(cartButtonRef);
  }, [setCartButtonRef]);

  const baseClassName = cn(className, 'cart-button', {
    'cart-button--active': isActive,
  });

  const content = {
    label: t('ebat:entities:layout.header.cart.no_access'),
    badge: 'x',
    className: 'cart-button--disabled',
    Component: DisabledCartButton,
  };
  if (hasCartAccesses && hasCreateAccess) {
    content.label = t('ebat:entities:layout.header.cart.new_cart');
    content.badge = '+';
    content.className = 'cart-button--new';
    content.Component = NewCartButton;
  }
  if (defaultCartId !== null && hasCartAccesses) {
    content.id = defaultCartId;
    content.label = defaultCart.name;
    content.badge = defaultCart.nb_items || 0;
    content.className = '';
    content.Component = CartNavLink;
  }

  return (
    <content.Component
      className={cn(baseClassName, content.className)}
      id={content.id}
    >
      <div ref={cartButtonRef}>
        <span
          className="inner-container cart-button__container"
          onMouseEnter={() => {
            if (!isCartPage && !isEcatalogPage && defaultCart?.nb_items > 0) {
              setIsVisible(true);
            }
          }}
        >
          <span className="cart-button__icon-container">
            <span className="cart-button__badge">
              <span
                className="cart-button__badge-label"
                data-qa-id="cart-product-number"
              >
                {content.badge}
              </span>
            </span>
            <BasketSvg className="cart-button__icon" />
          </span>
          <span className="cart-button__label" data-qa-id="cart-product-label">
            {content.label}
          </span>
        </span>
      </div>
    </content.Component>
  );
};

CartButton.defaultProps = {
  ...CartButtonDefaultProps,
};

CartButton.propTypes = {
  ...CartButtonPropTypes,
};

export default CartButton;
